<template>
  <el-container class="app-wrapper">
    <el-main class="main-container">
      <div class="content-view">
        <router-view />
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Book'
}
</script>

<style scoped>
/* 1. 整体容器铺满全屏 */
.app-wrapper {
  min-height: 100vh;
  background-color: #f4f5f7; /* 设置一个淡灰色背景，更具质感 */
}

/* 2. 核心：主区域避让固定导航栏 */
.main-container {
  padding: 0 !important; /* 覆盖 el-main 默认内边距 */
  overflow: visible;     /* 允许内容正常流动 */
}

.content-view {
  /* PC端避让：64px 是 NavBar 的高度 */
  padding-top: 64px;
  min-height: calc(100vh - 64px);
  margin: 0 auto;
  max-width: 1400px; /* 限制内容最大宽度，居中对齐，大屏更美观 */
}

/* 3. 移动端响应式适配 */
@media screen and (max-width: 768px) {
  .content-view {
    /* 移动端顶部避让：56px */
    padding-top: 56px;
    /* 移动端底部避让：56px 是底部导航栏高度 + 10px 间距 */
    padding-bottom: 66px;
    min-height: calc(100vh - 56px - 66px);
  }
}
</style>

<style>
/* 全局样式覆盖（可选）：去掉 body 默认边距 */
body {
  margin: 0;
  padding: 0;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
</style>
